import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { DAMO_AUTH_PATHS } from '../../auth-paths';
import { AuthService } from '../services/auth.service';
import { getParentPath } from './utils';

export const authenticatedGuard: CanActivateFn = async (route) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const isUserAuthenticated = await authService.isUserAuthenticated();
  if(isUserAuthenticated) {
    return true;
  }
  return router.createUrlTree([`${getParentPath(route)}/${DAMO_AUTH_PATHS.SIGN_IN}`]);
};